import dayjs from 'dayjs';

function buildDate(year, month, day, hour = 0, minute = 0, second = 0) {
  const parsed = new Date(year, month - 1, day, hour, minute, second);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function parseSyncDate(value) {
  if (value === null || value === undefined || value === '' || value === 'Jamais') {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (/^\d+$/.test(trimmed)) {
    const parsed = new Date(Number(trimmed));
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const dayjsParsed = dayjs(trimmed);
  if (dayjsParsed.isValid()) {
    return dayjsParsed.toDate();
  }

  const frMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ ,]+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
  if (frMatch) {
    const [, day, month, year, hour = '0', minute = '0', second = '0'] = frMatch;
    return buildDate(Number(year), Number(month), Number(day), Number(hour), Number(minute), Number(second));
  }

  const usMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4}),?\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i);
  if (usMatch) {
    const [, month, day, year, rawHour, minute, second = '0', suffix] = usMatch;
    let hour = Number(rawHour) % 12;
    if (suffix.toUpperCase() === 'PM') {
      hour += 12;
    }
    return buildDate(Number(year), Number(month), Number(day), hour, Number(minute), Number(second));
  }

  return null;
}

export function formatSyncDate(value, fallback = 'Jamais') {
  const parsed = parseSyncDate(value);
  return parsed ? dayjs(parsed).format('DD/MM/YYYY HH:mm') : fallback;
}

export function createSyncTimestamp(date = new Date()) {
  return date.toISOString();
}